// extracted by mini-css-extract-plugin
module.exports = {"main-header":"l3Sf","leftSide":"_2mWT","navbar-brand":"SPgP","links":"_3D9V","btn":"_29Yr","btn-secondary":"_12JH","accountArea":"_1kw0","rightSide":"_1jXn"};